import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/Literaryclub2023/components';
import { LiterarySidebar } from 'views/Literaryclub2023/components';
import ScienceClubSideBar from '../ScienceClubSideBar';
import Sidebar2025 from '../ScienceClub/Sidebar2025';

const AnimalWorld2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url_2025}/home/events-activities/association/ScienceClub/EVS/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/association/ScienceClub/EVS/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/association/ScienceClub/EVS/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/association/ScienceClub/EVS/4.webp`;
    const p5 = `${config.base_image_url_2025}/home/events-activities/association/ScienceClub/EVS/5.webp`;
    const p6 = `${config.base_image_url_2025}/home/events-activities/association/ScienceClub/EVS/6.webp`;


    
    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1,
            cols: 1,
        },
    ];

    return (
        <Main>

            <Container>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                                <Typography variant='h5' align='center' >
                               ‘Animal World’ (speaking about habitat, food and usefulness of Wild, Domestic and Aquatic animals with the help of collage)
                                </Typography>
                                <br />
                                {/* <Typography variant='h7' align='justify' >
                                Class 3: Vegan power,
                                Class 4: Plant Power Saves the World,
                                Class 5: Significance of spices in Indian Cuisine  
                                </Typography> */}
                                <Typography
                                    fontSize="x-small"
                                > <br />
                                    Classes: 2   Date: 01 August 2025

                                </Typography>

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The students of Class 2 participated enthusiastically in the EVS CCA Activity held on Friday, 01 August 2025, on the topic ‘Animal World’. It was enchanting to watch the children speak confidently about different type of animals, food, habitat and how they help humans and nature. From mooing cows to jumping dolphins and roaring lions the children brought the animal kingdom to life through lively presentation using charts and props. 
                               <br/>
                                The activity not only enhanced their speaking skills but also installed awareness about loving and protecting animals. The students combined their creative and oratorical skills to put up a wonderful presentation. It gave an insight as to what our students are capable of when exposed to the right stimuli. Overall the event was a grand success.
                                <br />
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Love nature and be kind to animals"
                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                            <Sidebar2025 />
                        </Box>
                        <Box marginBottom={4}>
                            <ScienceClubSideBar />

                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default AnimalWorld2025;